var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Method } from '@attraqt/http-client-common';
import validateSearchItemOptions from './models/validateSearchItemOptionsSchema';
import validateSearchGroupOptions from './models/validateSearchGroupOptionsSchema';
import validateSearchContext from './models/validateSearchContextSchema';
import validateAutocompleteOptionsContext from './models/validateAutocompleteOptionsSchema';
/**
 * Search module.
 *
 * Search for items using the xo-search API.
 */
var Search = /** @class */ (function () {
    function Search() {
        this.isInitialized = false;
    }
    Search.prototype.init = function (options, httpClient) {
        if (!options || !options.token) {
            throw Error('A token is required to initialize the search module.');
        }
        this.token = options.token;
        this.httpClient = httpClient;
        this.region = this.configureRegion(options);
        this.isInitialized = true;
    };
    Search.prototype.query = function (query, options, requestOptions, context) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.assertIsInit();
                if (options && !validateSearchItemOptions(options)) {
                    throw Error("The provided search options doesn't match the required format.");
                }
                if (context && !validateSearchContext(context)) {
                    throw Error("The provided search context doesn't match the required format.");
                }
                return [2 /*return*/, this.sendRequest('/search', query, options, context, requestOptions)];
            });
        });
    };
    Search.prototype.suggest = function (query, options, requestOptions, context) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.assertIsInit();
                if (options && !validateSearchGroupOptions(options)) {
                    throw Error("The provided group options don't match the required format.");
                }
                if (context && !validateSearchContext(context)) {
                    throw Error("The provided search context doesn't match the required format.");
                }
                return [2 /*return*/, this.sendRequest('/search/suggest', query, options, context, requestOptions)];
            });
        });
    };
    Search.prototype.autocomplete = function (query, options, requestOptions) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.assertIsInit();
                if (options && !validateAutocompleteOptionsContext(options)) {
                    throw Error("The provided autocomplete options don't match the required format.");
                }
                return [2 /*return*/, this.sendRequest('/search/autocomplete', query, options, undefined, requestOptions)];
            });
        });
    };
    Search.prototype.sendRequest = function (path, query, options, context, requestOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = __assign({ method: Method.Post, headers: { 'Content-Type': 'application/json' }, url: "https://api-".concat(this.region, ".attraqt.io").concat(path), body: JSON.stringify({
                                query: query,
                                token: this.token,
                                options: options,
                                context: context
                            }) }, requestOptions);
                        return [4 /*yield*/, this.httpClient.send(request)];
                    case 1:
                        response = _a.sent();
                        if (response.status < 300) {
                            return [2 /*return*/, JSON.parse(response.body)];
                        }
                        else {
                            throw new Error("HTTP Error ".concat(response.status, ": ").concat(response.body));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Search.prototype.assertIsInit = function () {
        if (!this.isInitialized) {
            throw Error('The search module must be initialized before using methods.');
        }
    };
    Search.prototype.configureRegion = function (_a) {
        var region = _a.region;
        return Object.values(Region).includes(region === null || region === void 0 ? void 0 : region.toLowerCase())
            ? region.toLowerCase()
            : Region.EU;
    };
    return Search;
}());
export { Search };
export var Region;
(function (Region) {
    Region["EU"] = "eu";
    Region["AU"] = "au";
    Region["US"] = "us";
})(Region || (Region = {}));
//# sourceMappingURL=search.js.map